<template>
    <b-modal
        v-model="shown"
        centered
        title="Add Group"
        lazy
    >

        <Spinner v-if="loading" />

        <b-container
            v-else
            fluid
        >
            <b-form-group>
                <div><label>Name</label></div>
                <b-form-input
                    v-model.trim="$v.name.$model"
                    type="text"
                    required
                />
                <b-form-invalid-feedback :force-show="$v.name.$dirty && !$v.name.required">
                    Please enter a group name.
                </b-form-invalid-feedback>
            </b-form-group>
            <!-- Description -->
            <b-form-group>
                <label>Description</label>
                <TextEditor
                    v-model="description"
                    :markdown="true"
                />
            </b-form-group>
            <!--/ Description -->
        </b-container>

        <div slot="modal-footer">
            <b-btn
                variant="default"
                class="mr-2"
                @click="handleClose()"
            >
                Close
            </b-btn>
            <Button
                variant="success"
                :disabled="loading || $v.$invalid"
                :loading="submitLoading"
                @click="handleSubmit()"
            >
                Save
            </Button>
        </div>

    </b-modal>
</template>

<script>
import '@toast-ui/editor/dist/toastui-editor.css';
import required from 'vuelidate/lib/validators/required';
import TextEditor from '@/components/TextEditor.vue';

export default {

    components: {
        TextEditor,
    },

    data() {
        return {
            shown: false,
            loading: false,
            submitLoading: false,
            name: '',
            description: '',
            froala: false,
        };
    },

    validations: {
        name: {
            required,
        },
    },

    created() {
        this.$eventBus.$on(this.$events.openAddGroupModal, () => {
            this.name = '';
            this.$v.$reset();
            this.shown = true;
        });
    },

    methods: {
        async handleSubmit() {
            this.submitLoading = true;
            await this.$store.dispatch('costable/storeGroup', {
                name: this.name,
                description: this.description,
            });
            this.submitLoading = false;
            this.handleClose();
        },
        handleClose() {
            this.shown = false;
        },
    },

};
</script>
